// removed by extract-text-webpack-plugin
module.exports = {"Breadcrumbs__link":"Breadcrumbs__link","breadcrumbsLink":"Breadcrumbs__link"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Breadcrumbs.css
// module id = 428
// module chunks = 0